export var TITLE = 'Anthropic';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.1;
export var COLOR_PRIMARY = '#F1F0E8';